export default __webpack_public_path__ + "static/media/home2-vector4.bcd24cb6.png";